import React from "react";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.css";
import * as serviceWorker from "src/serviceWorker";
import App from "src/App";
import "src/utils/i18n";
import "src/utils/Date";

if (window.location.host.indexOf("localhost") === 0) {
    const brandCssLink = document.getElementById("brand-css") as HTMLLinkElement;

    if (brandCssLink) {
        brandCssLink.href = "https://dev.wwportal.ch/api/designs/css/brand.css";
    }
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);

serviceWorker.unregister();
